module.exports = __webpack_public_path__ + "static/img/avatar-unknown.3730a975.png";